import posthog from "posthog-js";

const POSTHOG_KEY = "phc_sAwLDhKkW9n7Riu2WmCsN2xWwVX3G5FmNC6DYaC2PizR";
const POSTHOG_HOST = "https://eu.i.posthog.com";

let initialized = false;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    Cookiebot?: {
      consent: {
        statistics: boolean;
        marketing: boolean;
        preferences: boolean;
      };
    };
  }
}

export function initAnalytics() {
  if (initialized || !import.meta.env.PROD) return;
  initialized = true;

  // GA4 is loaded statically in index.html — Cookiebot handles consent and blocking.
  // PostHog needs manual opt-in/out based on Cookiebot consent.
  const hasConsent = window.Cookiebot?.consent?.statistics ?? false;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    capture_pageview: false,
    capture_pageleave: true,
    opt_out_capturing_by_default: !hasConsent,
    persistence: hasConsent ? "localStorage+cookie" : "memory",
  });

  // Listen for Cookiebot consent events to control PostHog
  window.addEventListener("CookiebotOnAccept", () => {
    if (window.Cookiebot?.consent?.statistics) {
      posthog.opt_in_capturing();
    }
  });

  window.addEventListener("CookiebotOnDecline", () => {
    posthog.opt_out_capturing();
  });
}

export function trackPageView(pathname: string) {
  if (!initialized) return;

  window.gtag?.("event", "page_view", { page_path: pathname });
  posthog.capture("$pageview", { $current_url: window.location.href });
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!initialized) return;

  window.gtag?.("set", { user_id: userId });
  posthog.identify(userId, properties);
}

export function resetAnalytics() {
  if (!initialized) return;

  posthog.reset();
}
